'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SENT = exports.SENT = 'SENT';
var FAILED = exports.FAILED = 'FAILED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/statusTypes.js
// module id = 893
// module chunks = 2 3